export function detectMac () {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
  const elem = document.querySelector('body')
  elem.classList.add(isMac ? 'body--mac' : 'body--not-mac')
  return true
}
